<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1 class="mb-3">افزودن نظرسنجی جدید</h1>
          <b-row>
            <b-col cols="12" md="8">
              <b-form-group label="عنوان نظرسنجی" label-for="title">
                <b-form-input
                  v-model="surveyDetails.name.tilte"
                  id="title"
                  trim
                  placeholder="نحوه تدریس استاد"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
              <b-form-group label="آیا نظرسنجی فعال است؟" label-for="isActive">
                <b-form-checkbox
                  v-model="surveyDetails.name.isActive"
                  id="isActive"
                  switch
                >
                  نظرسنجی فعال است؟ ({{
                    surveyDetails.name.isActive ? "بله" : "خیر"
                  }})
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
          <hr class="my-1" />
          <div class="d-flex align-items-center mb-2">
            <h3>سوال های نظرسنجی</h3>
            <b-button
              type="button"
              variant="success"
              size="sm"
              class="ml-1"
              @click="addNewQuestionsToSurvey"
            >
              افزودن سوال جدید
            </b-button>
          </div>

          <b-row>
            <template
              v-if="surveyDetails.body && surveyDetails.body.length > 0"
            >
              <b-col
                class="my-1"
                cols="12"
                v-for="(question, index) in surveyDetails.body"
                :key="index"
              >
                <single-question-form
                  :questionDetails="question"
                  :questionIndex="index"
                  @removeAnswerFromQuestion="removeAnswerFromQuestion"
                  @removeQuestionFromList="removeQuestionFromList"
                  @addAnswerToQuestion="addAnswerToQuestion"
                ></single-question-form>
              </b-col>
            </template>
            <template v-else>
              <p class="w-100 text-center">هیچ سوالی جهت نمایش وجود ندارد.</p>
            </template>
          </b-row>
          <b-row>
            <b-col cols="12">
              <div class="w-100 d-flex align-items-center justify-content-end">
                <b-button
                  type="button"
                  variant="success"
                  @click="createANewSurvey"
                >
                  ثبت
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
export default {
  data() {
    return {
      isLoading: false,
      surveyDetails: {
        name: {
          tilte: null,
          isActive: true,
        },
        body: [
          {
            questionTitle: null,
            responses: [
              {
                answerValue: null,
                answer: null,
                imageUrl: null,
                extraClass: null,
                extraStyle: null,
                guide: null,
              },
            ],
          },
        ],
      },
    };
  },
  methods: {
    convertNumbers2English(number) {
      return number.replace(/[\u0660-\u0669\u06f0-\u06f9]/g, function (c) {
        return c.charCodeAt(0) & 0xf;
      });
    },
    addNewQuestionsToSurvey() {
      this.surveyDetails.body.push({
        questionTitle: null,
        responses: [
          {
            answerValue: null,
            answer: null,
            imageUrl: null,
            extraClass: null,
            extraStyle: null,
            guide: null,
          },
        ],
      });
    },
    removeQuestionFromList(index) {
      this.surveyDetails.body.splice(index, 1);
    },
    removeAnswerFromQuestion(questionIndex, answerIndex) {
      this.surveyDetails.body[questionIndex].responses.splice(answerIndex, 1);
    },
    addAnswerToQuestion(index) {
      this.surveyDetails.body[index].responses.push({
        answerValue: null,
        answer: null,
        imageUrl: null,
        extraClass: null,
        extraStyle: null,
        guide: null,
      });
    },
    async createANewSurvey() {
      try {
        if (this.surveyDetails.body && this.surveyDetails.body.length > 0) {
          this.surveyDetails.body.forEach((surveyBody) => {
            if (surveyBody.responses && surveyBody.responses.length > 0) {
              surveyBody.responses.forEach((response) => {
                response.answerValue = this.convertNumbers2English(
                  response.answerValue
                );
              });
            }
          });
        }
        this.isLoading = true;
        let _this = this;
        let createSurveyByAdmin = new CreateSurveyByAdmin(_this);
        createSurveyByAdmin.setRequestParamDataObj(_this.surveyDetails);
        await createSurveyByAdmin.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ایجاد شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "نظرسنجی با موفقیت ایجاد شد.",
              },
            });
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ایجاد نشد!",
                icon: "AlertCircleIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد!",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    BFormCheckbox,
    BFormRadio,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    BInputGroup,
    BFormTextarea,
    BInputGroupAppend,
    SingleQuestionForm,
  },
};
import {
  BCard,
  BRow,
  BCol,
  BForm,
  BFormCheckbox,
  BFormRadio,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
  BInputGroup,
  BFormTextarea,
  BInputGroupAppend,
} from "bootstrap-vue";
import { CreateSurveyByAdmin } from "@/libs/Api/SuveyUserSurvey";
import SingleQuestionForm from "./SingleQuestionForm.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
</script>
<style scoped>
.custom-clear-btn {
  border: 1px solid #d8d6de !important;
  border-top-right-radius: 0.357rem !important;
  border-bottom-right-radius: 0.357rem !important;
}
</style>
